module.exports = __webpack_public_path__ + "img/dianpured.09146142.svg";